import React from 'react';
import Home from '../pageComponents/Home';

const Homepage = () => <Home />;

export default Homepage;
